import { Profiler, StrictMode } from 'react'
import type { ProfilerOnRenderCallback } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { recordReactCommit } from './telemetry'

const handleReactCommit: ProfilerOnRenderCallback = (
  id,
  phase,
  actualDuration,
  baseDuration,
  startTime,
  commitTime,
) => {
  recordReactCommit({
    id,
    phase,
    actualDuration,
    baseDuration,
    startTime,
    commitTime,
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Profiler id="AppShell" onRender={handleReactCommit}>
      <App />
    </Profiler>
  </StrictMode>,
)

